
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("3wJIS", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $94374e7e18df42f6$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //English (United Kingdom)
var $94374e7e18df42f6$export$2e2bcd8739ae039 = {
    'identity.account-menu.account-details.manage-profile-link': 'Account settings',
    'identity.account-menu.account-details.view-profile-tooltip': 'Profile',
    'identity.account-menu.account-menu-content.log-out-button': 'Log out',
    'identity.account-menu.account-menu-content.switch-account-button': 'Switch account',
    'identity.account-menu.account-menu-details.managed-account': 'This account is managed by <b>{managedBy}</b>',
    'identity.account-menu.account-menu-logged-out-state.log-in': 'Log in',
    'identity.account-menu.account-menu-popup.skeleton.tooltip': 'Account',
    'identity.account-menu.theme-switcher.dark.option': 'Dark',
    'identity.account-menu.theme-switcher.light.option': 'Light',
    'identity.account-menu.theme-switcher.match-browser.option': 'Match browser',
    'identity.account-menu.theme-switcher.theme-button': 'Theme'
};

});


//# sourceMappingURL=en_GB.064c27d0.js.map
